import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { SidebarProvider } from "../context/SidebarContext";
function AdminLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  // Auto-collapse sidebar on smaller desktop screens (1024px - 1280px), but keep full on mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
        setSidebarCollapsed(true);
      } else if (window.innerWidth >= 1280) {
        setSidebarCollapsed(false);
      } else {
        setSidebarCollapsed(false);
      }
    };

    // Set initial state
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const closeMobileSidebar = () => {
    setMobileSidebarOpen(false);
  };

  return (
    <SidebarProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors duration-300">
        {/* Sidebar */}
        <Sidebar
          isCollapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          isMobileOpen={mobileSidebarOpen}
          closeMobileSidebar={closeMobileSidebar}
        />

        {/* Main Content Area */}
        <div
          className={`min-h-screen transition-all duration-300 
          ${sidebarCollapsed ? 'lg:ml-[70px]' : 'lg:ml-[240px] xl:ml-[260px]'}`}
        >
          <Topbar toggleMobileSidebar={toggleMobileSidebar} />

          <main className="p-3 sm:p-4 lg:p-5 xl:p-6 min-h-[calc(100vh-3.5rem)] xl:min-h-[calc(100vh-4rem)]">
            <div className="animate-fadeIn max-w-[1920px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}

export default AdminLayout;
